<template>
  <div class="a-container-form">
    <div class="a-form">
      <div class="a-form__container">
        <textarea class="a-textarea" rows="3" :placeholder="$t('labels.question')" v-model="text"></textarea>

        <div class="a-form__input-file input-file--button-inline a-width-100-percent">
          <file-link :name="file.name"
                     :size="file.size"
                     v-if="file">
          </file-link>

          <file-picker :mode="file ? 'button' : 'link'"
                       :signing="false"
                       @prepared="onFileSelected">
          </file-picker>
        </div>
      </div>
      <div class="a-form__submit">
        <button class="gui-btn gui-btn--red gui-btn--w-184" @click.prevent="onSendClick">{{$t('buttons.send')}}</button>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      lot: Object
    },

    data: () => ({
      text: undefined,
      file: undefined
    }),

    methods: {
      onFileSelected(file) {
        this.file = file;
      },

      async onSendClick() {
        this.runBlockerAction(async() => {
          try {
            await this.$store.dispatch('postLotComment', {
              lotId: this.lot.id,
              text: this.text,
              file: this.file
            });

            this.file = undefined;
            this.text = undefined;
          }
          catch(e) {
            console.error('failed sending comment for lot', e);
            this.globalErrorHandler(e);
          }
        });
      },
    }
  }
</script>

<style scoped>

</style>
